import Toman from "../../Utilities/Toman";
import Modal from "../../Utilities/Modal";
import { useState } from "react";
import ApiRoute from "../../../helper/api";
import {
  formatNumberWithDots,
  getDateAsReadableFormat,
} from "../../../helper/general";
import ProductSelect from "../../Product/ProductSelect";
import SelectCoordinates from "../../Coordinates/SelectCoordinates";
import CategorySelect from "../../Product/Category/CategorySelect";
import { useEffect } from "react";
import ShopSelect from "../../Shop/ShopSelect";

export default function QuickAddGiftCardToProducts({ closeModal }) {
  const [sendData, setSendData] = useState(null);
  const [data, setData] = useState(null);
  const [updateData, setUpdateData] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const res = await ApiRoute.product.gifts.index.fn();
      if (res?.status_code === 200) {
        setData(res.results.data);
      }
      setLoading(false);
    })();
  }, [updateData])

  async function handleSubmit() {
    const res = await ApiRoute.product.gifts.create.fn(sendData);
    if (res?.status_code === 200) {
      setUpdateData(updateData + 1);
    }
  }

  async function handleDelete(id) {
    if (window.confirm('آیا می خواهید این کارت هدیه را حذف کنید؟')) {
    const res = await ApiRoute.product.gifts.delete.fn(id);
      if (res?.status_code === 200) {
        setUpdateData(updateData + 1);
      }
    }
  }
  return (
    <Modal isOpen={true} onClose={closeModal}>
      <div className="page-title mb-3">
        <span className="inline-block bg-white text-xs text-purple-1 pl-3">
          مدیریت کارت هدیه محصولات
        </span>
      </div>
      <div className="form grid-form grid grid-cols-1 text-xs gap-3 my-6">
        <div>
          <label>دسته بندی محصولات</label>
          <CategorySelect
            fixed={true}
            assignItem={(s) => {
              setSendData({...sendData, category: s})
              //setCategory(s)
            }}
          />
        </div>
        <div>
          <label>فروشگاه</label>
          <ShopSelect
                                multiple={false}
                                hasFrontEnd={true}
                                assignItem={(v) => {
                                    if(v?._id){
                                        setSendData({...sendData, shop_id: v._id});
                                    }
                                }}
                            />
        </div>
        <div>
          <div className="lg:flex justify-between items-center pb-4">
            <div className="flex gap-5">
              <label>
                رنگ بکگراند
                <input
                  onChange={(e) => {
                    setSendData({...sendData, color: e.target.value})
                  }}
                  className="w-25 shadow"
                  type="color"
                />
              </label>
              <label>
                رنگ متن
                <input
                  onChange={(e) => {
                    setSendData({...sendData, text_color: e.target.value})
                  }}
                  className="w-25 shadow"
                  type="color"
                />
              </label>
            </div>
          </div>
          <div className="grid lg:flex gap-4">
            <input
              placeholder="متن کارت هدیه"
              onKeyUp={(e) => {
                setSendData({...sendData, text: e.target.value})
              }}
              type="text"
            />
          </div>
        </div>

        <button onClick={handleSubmit} className="btn-green px-5 py-2">
          افزودن کارت هدیه
        </button>

      </div>

    
      <div>
        <h4>کارت هدیه های اضافه شده</h4>
        <table className="table-auto w-full mt-4 text-11 block sm:table">
          <thead>
                <tr>
                    <td>متن</td>
                    <td>دسته بندی</td>
                    <td></td>
                </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={3} className="text-center py-4">در حال دریافت اطلاعات...</td>
              </tr>
            ) : data?.length === 0 ? (
              <tr>
                <td colSpan={3} className="text-center py-4">کارت هدیه‌ای اضافه نشده است.</td>
              </tr>
            ) : (
              data?.map((item) => (
                <tr key={item._id} className="text-center">
                  <td className="py-2 px-4 border-b">{item.text}</td>
                  <td className="py-2 px-4 border-b">
                    {item.categories && Array.isArray(item.categories)
                      ? item.categories.map((cat, idx) => (
                          <span key={cat.id || idx}>
                            {cat.label}
                            {idx < item.categories.length - 1 ? '، ' : ''}
                          </span>
                        ))
                      : ''}
                  </td>
                  <td className="py-2 px-4 border-b">
                    <button onClick={() => handleDelete(item._id)} className="btn-red btn-sm py-0">حذف</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>


      <div className="flex justify-end mt-4">
      </div>
    </Modal>
  );
}
